<template>
    <a-progress-bar />
</template>

<script>

import { AProgressBar } from '../ui'

export default {
    name: 'ProgressBar',
    components: {
        AProgressBar
    },
    setup: (props, ctx) => {
        return {}
    },
}
</script>